export const SIDEBAR_EXPANDED_WIDTH_PX = 302
